module.exports = __webpack_public_path__ + "static/media/Шаг 4.4d8cc88a.png";